import React, { Component } from 'react';
import Step from 'bee-step';
const { Steps } = Step;
require('bee-step/build/Step.css');
require('./index.less');
export default class NCStep extends Component {
	render() {
        return <Step {...this.props} />;
	}
}

NCStep.NCSteps = Steps;
